<template>
  <div>
    <UiSingleSelect
      v-model="currentClass"
      :title="pluralToSingular(className)"
      label="title"
      :select-object-without-reduce-key="true"
      :search-through-api="true"
      :options="usersClassList"
      :is-position-top="isMobileView"
      drop-down-container="w-full text-xxs sm:text-xs md:text-xs lg:text-sm"
      :select-box-classes="`h-9 md:h-10 ${
        isBlinking && 'shadow-purple-100 border-primary-purple-300'
      }`"
      container-classes="min-w-[108px]"
      title-classes="pl-3 sm:pl-0 lg:text-sm sm:text-xxs text-[9px]"
      input-value-classes="text-xxs sm:text-xs md:text-xs lg:text-sm"
      :disabled="!currentCampusScope"
      :no-error="true"
      :hide-title="isTabView"
      @search="filterClassList"
      @deSelect="switchClass(currentClass)"
      @change="switchClass(currentClass)"
      @notifyToSelectInput="notifySelectCampusFirst"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FILTER_KEYS from '@src/constants/filter-constants.js'
import UiSingleSelect from '@components/UiElements/UiSingleSelect.vue'
import { buildWhereQuery } from '@utils/filters/index'
import { pluralToSingular } from '@/src/utils/generalUtil'
import { useBlinkField, BLINK_KEYS } from '@src/utils/layoutUtils.js'

export default {
  components: {
    UiSingleSelect,
  },

  data() {
    return {
      classesNotAllowerdFor: ['pickup_person'],
      currentClass: '',
      classBlinkField: false,
    }
  },

  computed: {
    ...mapState({
      currentCampusScope: (state) => state.layout.currentCampusScope,
      currentClassScope: (state) => state.layout.currentClassScope,
      classRoles: (state) => state.layout.currentSelectedSectionRoles,
      activeRole: (state) => state.layout.activeRole,
      isTabView: (state) => state.layout.isTabView,
      usersClassList: (state) => state.classes.usersClassList,
      className: (state) => state.featureNaming.routerList.CLASSES.DISPLAY_NAME,
      blinkClassTrigger: (state) => state.layout.blinkClassTrigger,
      isMobileView: (state) => state.layout.isMobileView,
    }),
    isBlinking() {
      return this.getBlinkField ? this.getBlinkField() : false
    },
  },
  watch: {
    currentCampusScope: {
      handler() {
        this.getUserClasses()
        this.setCurrentSelectedClass('')
        this.currentClass = ''
      },
    },
    currentClassScope: {
      handler() {
        if (this.currentClassScope?.id && this.stopBlinking) {
          this.stopBlinking()
        }
      },
    },
    blinkClassTrigger() {
      if (this.getBlinkField && !this.getBlinkField()) {
        this.blinkClassField()
      }
    },
  },

  created() {
    // Initialize generic blink field for class
    const api = useBlinkField && useBlinkField(BLINK_KEYS.CLASS)
    if (api) {
      this.blinkClassField = api.startBlink
      this.stopBlinking = api.stopBlink
      this.getBlinkField = api.getBlink
    }
    // Set up a watcher to sync the local classBlinkField with composable state
    this.$watch(
      () => this.getBlinkField(),
      (blinkFieldValue) => {
        this.classBlinkField = blinkFieldValue
      },
      { immediate: true },
    )

    if (this.currentCampusScope && !this.classesNotAllowerdFor.includes(this.activeRole)) {
      this.getUserClasses()
    }
    if (this.currentClassScope?.id) {
      this.currentClass = this.currentClassScope
    }
  },
  methods: {
    pluralToSingular,
    notifySelectCampusFirst() {
      if (!this.currentCampusScope) {
        this.$store.commit(
          'toast/NEW',
          { type: 'error', message: this.$t('toast.SELECT_CAMPUS_FIRST') },
          { root: true },
        )
        if (this.$parent && this.$parent.blinkCampusField) {
          this.$parent.blinkCampusField()
        }
      }
    },
    switchClass(selectedClass) {
      if (this.stopBlinking) {
        this.stopBlinking()
      }
      this.setCurrentSelectedClass(selectedClass)
      this.setcurrentSelectedSection('')
      this.getUserClasses()
    },
    filterClassList(query = '') {
      const payload = {
        $where: { ...buildWhereQuery(FILTER_KEYS.ILIKE, 'title', query) },
      }
      this.getUserClasses(payload)
    },
    ...mapActions('layout', ['setcurrentSelectedSection', 'setCurrentSelectedClass']),
    ...mapActions('classes', ['getUserClasses']),
  },
}
</script>
